
	import { Observer } from 'mobx-vue';
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import CloseSVG from '@/components/CloseSVG.vue';

	@Observer
	@Component({
		components: { CloseSVG }
	})
	export default class SnackbarBottom extends Vue {
		@Prop() text;
		@Prop() actionText;
		@Prop() closeButton?;

		action() {
			this.$emit('action');
		}

		close() {
			this.$emit('close');
		}
	}
